module.exports = __webpack_public_path__ + "static/Apercu-Light-a5229c50f1bd6fb1d2f1cadf7346e371.woff";